import React from "react";
import { Link } from "react-router-dom";
import styles from "./BlogArticlesCollection.module.css";

interface BlogArticlesCollectionProps {
  title: string | null;
  articles: Array<{
    id: number;
    url: string;
    title: string;
    description: string;
    cover: {
      formats: {
        thumbnail: { url: string };
        small: { url: string };
        medium: { url: string };
        large: { url: string };
      };
      url: string;
    } | null;
    blog_categories: Array<{
      id: number;
      name: string;
      locale: string;
    }>;
    blog_author: {
      name: string;
      avatar: {
        formats: {
          thumbnail: { url: string };
        };
      };
    } | null;
    publishedAt: string | null;
  }>;
}

const BlogArticlesCollection: React.FC<BlogArticlesCollectionProps> = ({
  title,
  articles,
}) => {
  const imageBaseUrl = process.env.REACT_APP_IMAGE_FOLDER;

  if (!articles?.length) return null;

  return (
    <section className={styles.collectionSection}>
      <div className={styles.titleWrapper}>
        {title && <h2 className={styles.title}>{title}</h2>}
      </div>

      <div className={styles.articlesContainer}>
        <div className={styles.articlesScroll}>
          {articles.map((article) => (
            <article key={article.id} className={styles.articleCard}>
              <Link to={`/blog/${article.url}`} className={styles.articleLink}>
                {article.cover && (
                  <div className={styles.imageWrapper}>
                    <img
                      src={`${
                        article.cover.formats?.small?.url || article.cover.url
                      }`}
                      alt={article.title}
                      className={styles.image}
                    />
                  </div>
                )}
                <div className={styles.content}>
                  <div className={styles.categoriesWrapper}>
                    {article.blog_categories?.map((category) => (
                      <span key={category.id} className={styles.category}>
                        {category.name}
                      </span>
                    ))}
                  </div>
                  <h3 className={styles.articleTitle}>{article.title}</h3>
                  <p className={styles.excerpt}>{article.description}</p>
                  {article.blog_author && (
                    <div className={styles.author}>
                      {article.blog_author.avatar?.formats?.thumbnail?.url && (
                        <img
                          src={`${imageBaseUrl}${article.blog_author.avatar.formats.thumbnail.url}`}
                          alt={article.blog_author.name}
                          className={styles.authorImage}
                        />
                      )}
                      <span>Por {article.blog_author.name}</span>
                    </div>
                  )}
                </div>
              </Link>
            </article>
          ))}
        </div>
        <div className={styles.gradientOverlay} />
      </div>
    </section>
  );
};

export default BlogArticlesCollection;
